(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("signature", [], factory);
	else if(typeof exports === 'object')
		exports["signature"] = factory();
	else
		root["signature"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 